export {
  normalizeBrazilianTaxId,
  validateCpfOrCnpj,
  formatDocumentDisplay,
  countRawChars,
  caretPositionFromRawIndex,
  onCnpjInput,
  onDocumentInput,
} from './brazilianTaxId';

export {
  validateCpf,
  sanitizeCpf,
  formatCpfDisplay,
  CPF_LENGTH,
} from './cpf';

export {
  validateCnpj,
  sanitizeCnpj,
  formatCnpjDisplay,
  looksLikeCnpj,
  CNPJ_LENGTH,
} from './cnpj';
